export type AppThemeId = "flownect" | "midnight" | "ocean" | "forest" | "sunset" | "mono";

export type AppThemeSpec = {
  id: AppThemeId;
  name: string;
  mode: "light" | "dark";
  accent: string;
  page: string;
  base: string;
  text: string;
  neutralHue: number;
  neutralSaturation: number;
};

export const APP_THEME_SPECS: AppThemeSpec[] = [
  {
    id: "flownect",
    name: "Flownect",
    mode: "light",
    accent: "#FB8E00",
    page: "#F4F6F9",
    base: "#FFFFFF",
    text: "#0F172A",
    neutralHue: 215,
    neutralSaturation: 0.18,
  },
  {
    id: "midnight",
    name: "Midnight",
    mode: "dark",
    accent: "#6EA8FE",
    page: "#0B0F16",
    base: "#161B23",
    text: "#E6EDF3",
    neutralHue: 215,
    neutralSaturation: 0.16,
  },
  {
    id: "ocean",
    name: "Ocean",
    mode: "light",
    accent: "#1B6AA5",
    page: "#EEF5FB",
    base: "#F7FBFE",
    text: "#0D2C42",
    neutralHue: 205,
    neutralSaturation: 0.24,
  },
  {
    id: "forest",
    name: "Forest",
    mode: "light",
    accent: "#3F6B46",
    page: "#F1F5EF",
    base: "#F8FAF7",
    text: "#1E3323",
    neutralHue: 130,
    neutralSaturation: 0.16,
  },
  {
    id: "sunset",
    name: "Sunset",
    mode: "light",
    accent: "#8B3FA5",
    page: "#F8F0F7",
    base: "#FDF7FC",
    text: "#3B1436",
    neutralHue: 305,
    neutralSaturation: 0.18,
  },
  {
    id: "mono",
    name: "Mono",
    mode: "light",
    accent: "#3F3F46",
    page: "#F4F4F5",
    base: "#FAFAFA",
    text: "#18181B",
    neutralHue: 240,
    neutralSaturation: 0.04,
  },
];

export const DEFAULT_APP_THEME_ID: AppThemeId = "flownect";

export const getThemeSpec = (id?: string | null): AppThemeSpec =>
  APP_THEME_SPECS.find((spec) => spec.id === id) ?? APP_THEME_SPECS[0];
